import { is } from '../../../util/is';
import { IAdsCheckoutStore } from './ads-checkout-type';

export const validateAdsSelection = (state: IAdsCheckoutStore): string => {
  if (state.model.ads.some(ad => !is.FilledText(ad.name))) {
    return 'Title is required for all ads';
  }

  if (state.model.ads.some(ad => !is.FilledText(ad.typeId))) {
    return 'Type is required for all ads';
  }

  return '';
};



// WEBPACK FOOTER //
// ./src/modules/ads-checkout/parts/ads-checkout-util.ts